import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { OptionTypeService } from 'app/modules/option-type/services/option-type.service';
import module from 'app/modules/option-type/option-type.module';

@Component({
  selector: 'app-edit-option-type-details',
  templateUrl: './edit-option-type-details.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: module,
  styleUrls: ['./edit-option-type-details.component.scss']
})
export class EditOptionTypeDetailsComponent {
  public optionItemBody = {
    id: '',
    optionId: '',
    name: '',
    alternate: ''
  }

  public isLoading: boolean = false
  public isSuccess: boolean = false

  constructor(
    public dialogRef: MatDialogRef<EditOptionTypeDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public optionItem: any,
    public dialog: MatDialog,
    private metadataService: OptionTypeService) {
    this.optionItemBody = {...this.optionItem} 
  }

  isOptionTypeItemChange() {
    return JSON.stringify(this.optionItem) === JSON.stringify(this.optionItemBody);
  }

  updateDetails() {
    this.isLoading = true

    this.metadataService.updateOptionItem(this.optionItemBody.id, this.optionItemBody).subscribe((res) => {
      this.isLoading = false
      this.isSuccess = true
      this.closeDialog()
    })

  }

  closeDialog(): void {
    this.dialogRef.close(this.isSuccess);
  }
}
